export const warningTypeMenu = [
  { value: 0, name: 'すでに登録されている' },
  { value: 1, name: '住所に記号が含まれている' },
  { value: 2, name: '住所に脱字の可能性がある' },
  { value: 3, name: '郵便番号に誤りがある' },
  { value: 4, name: '住所に誤字の可能性がある' },
  { value: 5, name: '指定の住所は指定の郵便番号ではない' },
  { value: 6, name: 'キーマンデータベースと同じアドレスで登録されている' },
]

export const linkCorporationStatusMenu = [
  { name: '紐付け済みのみ表示', value: 2 },
  { name: '紐付けエラーのみ表示', value: 3 },
  { name: '未紐付けのみ表示', value: 0 },
]

export const investBusinessAreaNestedMenu = [
  {
    // 数値で記載際うまく動かないので文字列にしてます。文字列でもESの検索は正しく動く
    // DBのidを記載しているので、idが更新された場合は修正してください。
    // @see コメントアウトしているのは、データがないため。定期的にデータを確認して件数を増えている場合、表示・非表示を確認すること。
    name: 'トレンド', value: 'trend', submenu: [
      { name: 'ソフトウェア・SaaS', value: "1" },
      { name: 'ESGs・SDGs', value: "2" },
      { name: '広告・MA', value: "3" },
      { name: 'セキュリティ', value: "4" },
      { name: '採用', value: "5" },
      { name: 'AI', value: "6" },
      { name: 'DX', value: "7" },
      { name: '海外進出', value: "58" },
      { name: '専門役員の設置情報', value: "59" },
      // { name: 'アプリ', value: "60" },
      { name: 'コンサルティング', value: "61" },
      // { name: '決算処理', value: "62" },
      { name: 'メディア', value: "63" },
      // { name: '電子契約', value: "64" },
      { name: '業績・財務指標', value: "65" },
      { name: '設備投資・資本投資', value: "66" },
      { name: '人的資本', value: "67" },
      { name: '株主還元姿勢', value: "68" },
      { name: '技術開発・イノベーション', value: "69" },
      { name: '資本政策・財務戦略', value: "70" },
      { name: 'ガバナンス', value: "71" },
      { name: '子会社・M&A/連結範囲', value: "72" },
      { name: 'リスクマネジメント', value: "73" },
      { name: '成長戦略・将来志向', value: "74" },
      { name: '100億円宣言企業', value: "76" },
      { name: 'デバイス開発・販売', value: "77" },
      { name: '運用保守', value: "78" },
      { name: '地方創生', value: "79" },
      { name: '人材紹介', value: "80" },
      // yuryo-kigyo パイプライン由来の国の認定・表彰リスト 4 タグ。
      // Posto-backend PR #4040 で business_areas マスターに登録され (artisan
      // command:user_business_area:update により採番)、本番 DB の id=84-87 を value に対応。
      { name: 'グローバルニッチトップ企業100選', value: "84" },
      { name: 'はばたく中小企業・小規模事業者300社', value: "85" },
      { name: '地域未来牽引企業', value: "86" },
      { name: '経産省認定スタートアップ', value: "87" },
    ]
  },
  {
    name: 'その他', value: 'other', submenu: [
      { name: 'デザイン', value: "8" },
      { name: 'UX/UIデザイン', value: "9" },
      { name: 'ブランディング', value: "10" },
      { name: 'EC', value: "11" },
      { name: 'EV充電', value: "12" },
      { name: 'ITインフラ', value: "13" },
      { name: 'SNS', value: "14" },
      { name: 'イベント企画運営', value: "15" },
      { name: 'カスタマーサポート', value: "16" },
      { name: 'クリエイティブ', value: "17" },
      { name: 'コミュニティ構築', value: "18" },
      { name: 'タスク管理', value: "19" },
      { name: 'データ活用', value: "20" },
      { name: 'データ分析', value: "21" },
      { name: 'ドローン', value: "22" },
      { name: 'プロジェクト管理', value: "23" },
      { name: 'マニュアル作成・共有', value: "24" },
      { name: 'リスク管理', value: "25" },
      { name: 'ロボット', value: "26" },
      { name: '印刷機器開発', value: "27" },
      { name: '画像処理', value: "28" },
      // { name: '学習体験', value: "29" },
      { name: '機械学習', value: "30" },
      { name: '勤怠管理', value: "31" },
      { name: '経費精算', value: "32" },
      { name: '健康経営', value: "33" },
      { name: '研修', value: "34" },
      { name: '顧客体験', value: "35" },
      { name: '語学研修', value: "36" },
      { name: '在庫管理', value: "37" },
      { name: '資材調達', value: "38" },
      // { name: '補助金申請', value: "39" },
      // { name: '社員評価', value: "40" },
      // { name: '生成AI', value: "41" },
      { name: '従業員の健康増進・福祉', value: "42" },
      { name: '障がい者雇用', value: "43" },
      { name: '新規事業', value: "44" },
      { name: '人材育成', value: "45" },
      { name: '人事労務処理', value: "46" },
      // { name: '請求書処理', value: "47" },
      { name: '組織開発', value: "48" },
      { name: '組織活性化', value: "49" },
      { name: '知識管理', value: "50" },
      { name: '電話反響測定', value: "51" },
      { name: '投資管理', value: "52" },
      { name: '働き方改革', value: "53" },
      { name: '動画コンテンツ', value: "54" },
      { name: '非財務情報活用', value: "55" },
      { name: '不動産登記簿取得・管理', value: "56" },
      // { name: '福祉・介護機器', value: "57" },
    ]
  }
];

export const webToolNestedMenu = [
  {
    name: '広告タグ', value: 'ad_tag', submenu: [
      { name: 'GA4 (Google Analytics 4)', value: '1'},
      { name: 'Google動的リマーケティングタグ', value: '2'},
      { name: 'Yahoo!動的リターゲティングタグ', value: '3'},
      { name: 'FBタグ (Facebook Pixel)', value: '4'},
      { name: 'Criteoタグ', value: '5'},
      { name: 'RTBHouseタグ', value: '6'},
      { name: 'Google Ads（コンバージョン/リマーケティング）', value: '7'},
      { name: 'Yahoo!広告コンバージョンタグ', value: '8'},
      { name: 'Twitter広告タグ', value: '9'},
      { name: 'Microsoft広告（UETタグ）', value: '10'},
      { name: 'TikTok Pixelタグ', value: '11'},
      { name: 'LINE広告（LINE Tag）', value: '12'},
      { name: 'Outbrainタグ', value: '13'},
      { name: 'Taboolaタグ', value: '14'},
      { name: 'AdRollタグ', value: '15'},
      { name: 'Revcontentタグ', value: '16'},
      { name: 'AppLovinタグ', value: '17'},
      { name: 'Sizmek（Amazon広告）', value: '18'},
      { name: 'TradeDeskタグ（TTD）', value: '19'}
    ]
  },
  {
    name: 'マーケティングオートメーション', value: 'marketing_automation', submenu: [
      { name: 'Salesforce（Marketing Cloud, Pardot）', value: '20'},
      { name: 'HubSpot', value: '21'},
      { name: 'Marketo', value: '22'},
      { name: 'Eloqua（Oracle）', value: '23'},
      { name: 'Adobe Marketo Engage', value: '24'},
      { name: 'ActiveCampaign', value: '25'},
      { name: 'Mailchimp', value: '26'}
    ]
  },
  {
    name: 'アナリティクス', value: 'analytics', submenu: [
      { name: 'Google Tag Manager（GTM）', value: '27'},
      { name: 'Adobe Analytics（旧Omniture）', value: '28'},
      { name: 'Mixpanel', value: '29'},
      { name: 'Matomo（旧Piwik）', value: '30'},
      { name: 'Hotjar', value: '31'},
      { name: 'Crazy Egg', value: '32'}
    ]
  },
  {
    name: 'チャットツール', value: 'chat_tools', submenu: [
      { name: 'Zendesk Chat（旧Zopim）', value: '33'},
      { name: 'Intercom', value: '34'},
      { name: 'LiveChat', value: '35'},
      { name: 'Drift', value: '36'},
      { name: 'Tidio', value: '37'},
      { name: 'Crisp Chat', value: '38'}
    ]
  },
  {
    name: 'A/Bテスト', value: 'ab_test', submenu: [
      { name: 'Google Optimize', value: '39'},
      { name: 'Optimizely', value: '40'},
      { name: 'VWO（Visual Website Optimizer）', value: '41'},
      { name: 'Convert.com', value: '42'}
    ]
  },
  {
    name: 'CDN', value: 'cdn', submenu: [
      { name: 'Cloudflare', value: '43'},
      { name: 'Akamai', value: '44'}
    ]
  },
  {
    name: 'フォント', value: 'fonts', submenu: [
      { name: 'Google Fonts', value: '45'},
      { name: 'Font Awesome', value: '46'}
    ]
  },
  {
    name: 'セキュリティ', value: 'security', submenu: [
      { name: 'reCAPTCHA', value: '47'}
    ]
  }
];

export const corporationStatisticsChangeNestedMenu = [
  {
    name: '増加', value: 'up', submenu: [
      { name: '売上高増加', value: '1' },
      { name: '平均年収増加', value: '3' },
      { name: '平均年齢増加', value: '5' },
      { name: '平均勤続年数増加', value: '7'},
      { name: '資本金増加', value: '9'},
      { name: '従業員数増加', value: '11'},
    ]
  },
  {
    name: '減少', value: 'down', submenu: [
      { name: '売上高減少', value: '2' },
      { name: '平均年収減少', value: '4' },
      { name: '平均年齢減少', value: '6' },
      { name: '平均勤続年数減少', value: '8'},
      { name: '資本金減少', value: '10'},
      { name: '従業員数減少', value: '12'},
    ]
  }
];

// 役職
export const honorificNestedMenu = [
  {
    name: '一般役職', value: 'general', submenu: [
      { name: '代表取締役', value: 'president' },
      { name: '取締役', value: 'director' },
      { name: '会長', value: 'kaichou' },
      { name: 'COO', value: 'coo' },
      { name: 'CTO', value: 'cto' },
      { name: 'CFO', value: 'cfo' },
      { name: 'CHRO(CHO)', value: 'chro' },
      { name: 'CSO', value: 'cso' },
      { name: 'CDO', value: 'cdo' },
      { name: 'CIO', value: 'cio' },
      { name: 'CISO', value: 'ciso' },
      { name: 'CMO', value: 'cmo' },
      { name: 'その他CxO', value: 'other_cxo' },
      { name: '執行役員', value: 'corporate_officer' },
      { name: "役員", value: "yakuin"},
      { name: '顧問', value: 'adviser' },
      { name: '専務', value: 'senior_managing_director' },
      { name: '常務', value: 'managing_director' },
      { name: '支社長', value: 'branch_president' },
      { name: '部長', value: 'department_manager' },
      { name: '次長', value: 'assistant_department_manager' },
      { name: 'センター長', value: 'center_manager' },
      { name: '工場長', value: 'factory_manager' },
      { name: 'マネージャー', value: 'manager' },
      { name: 'ディレクター', value: 'other_director' },
      { name: '室長', value: 'chief' },
      { name: '課長', value: 'section_chief' },
      { name: '所長', value: 'center_president' },
      { name: 'リーダー', value: 'leader' },
      { name: '主査', value: 'chief_examiner' },
    ]
  },
  {
    name: 'その他役職', value: 'others', submenu: [
      { name: '理事', value: 'riji' },
      { name: "監査役", value: "auditor" },
      { name: "相談役", value: "counselor" },
      { name: "推進役", value: "suishinyaku" },
      { name: "調査役", value: "chousayaku" },
      { name: "創業者", value: "sougyousha" },
      { name: '主管', value: 'syukan' },
      { name: '主任', value: 'syunin' },
      { name: '副長', value: 'fukuchou' },
      { name: 'チーフ', value: 'other_chief' },
      { name: 'シニア', value: 'senior' },
      { name: 'シニア・エキスパート', value: 'senior_expert' },
      { name: '補佐', value: 'hosa' },
      { name: '管理者', value: 'kanrisya' },
      { name: 'フェロー', value: 'fellow' },
      { name: '店長', value: 'tenchou' },
      { name: 'セクター長', value: 'sector_manager' },
      { name: 'グループ長', value: 'group_leader' },
      { name: 'エリア長', value: 'area_leader' },
      { name: 'チーム長', value: 'team_leader' },
      { name: 'ユニット長', value: 'unit_leader' },
      { name: 'ブロック長', value: 'block_leader' },
      { name: 'プロジェクト長', value: 'project_leader' },
      { name: '統括長', value: 'toukatsu' },
      { name: '係長', value: 'kakarichou' },
      { name: '班長', value: 'hanchou' },
      { name: 'その他の長', value: 'chou_other' },
      { name: '責任者', value: 'officer' },
      { name: 'アドバイザー', value: 'other_adviser' },
      { name: 'パートナー', value: 'partner' },
      { name: 'エキスパート', value: 'expert' },
      { name: '技師長', value: 'chief_engineer' },
      { name: '配属(部付)', value: 'haizoku_bu' },
      { name: '配属(局付)', value: 'haizoku_kyoku' },
      { name: '配属(課付)', value: 'haizoku_ka' },
      { name: '配属(その他)', value: 'haizoku_other' },
      { name: '駐在', value: 'chuzai' },
      { name: '頭取', value: 'toudori' },
      { name: '担当', value: 'tantou' },
      { name: '専門員', value: 'senmonin' },
      { name: '資格職', value: 'shikakusyoku' },
      { name: '支配人', value: 'shihainin' },
      { name: 'スペシャリスト', value: 'specialist' },
      { name: '主席', value: 'shuseki' },
      { name: '研究・教育職', value: 'kenkyu' },
      { name: '官職', value: 'kansyoku' },
      { name: '科長', value: 'kachou' },
      { name: '部員', value: 'buin' },
      { name: '委員会', value: 'iinkai' },
      { name: 'ヘッド', value: 'head' },
      { name: 'ゼネラルスタッフ', value: 'general_staff' },
      { name: 'コーチ', value: 'coach' },
      { name: 'その他', value: 'other' },
    ]
  }
];

// 部門
// @see 修正する場合 バックエンドのwww/common/app/Console/Commands/GenerateNewExeNotificationCommand.phpも修正すること。
export const departmentNestedMenu = [
  {
    name: 'トレンド', value: 'trend', submenu: [
      { name: '健康経営', value: 'health_management' },
      { name: '働き方改革', value: 'work_style_reform' },
      { name: 'SDGs', value: 'sdgs' },
      { name: 'DX・デジタルトランスフォーメーション', value: 'dx' },
      { name: 'ICT', value: 'ict' },
      { name: 'ダイバーシティ', value: 'diversity' },
      { name: '情報セキュリティ', value: 'information_security' },
      { name: 'ESG', value: 'esg' },
      { name: 'IoT', value: 'iot' },
      { name: 'サステナブル', value: 'sustainable' },
      { name: 'デジタルイノベーション', value: 'digital_innovation'},
      { name: 'ロボット', value: 'robot' },
      { name: 'AI・人工知能', value: 'ai' },
      { name: '人的資本', value: 'human_capital_resource_management' },
      { name: '脱炭素・環境', value: 'decarbonization_environment' },
    ]
  },
  {
    name: 'バックオフィス部門', value: 'back_office_department', submenu: [
      { name: '経営企画', value: 'corporate_planning' },
      { name: '経営推進', value: 'management_promotion' },
      { name: '社長室', value: 'president_office' },
      { name: '秘書室', value: 'secretarial_office' },
      { name: '人事・HR', value: 'human_resources' },
      { name: '人材・人財', value: 'human_capital' },
      { name: '情報システム', value: 'information_system' },
      { name: 'IT', value: 'it' },
      { name: '情報通信', value: 'information_communication' },
      { name: 'システム', value: 'system' },
      { name: 'エンジニアリング', value: 'engineering' },
      { name: '総務', value: 'general_affairs' },
      { name: '法務', value: 'legal' },
      { name: '管理', value: 'management' },
      { name: '経理・財務', value: 'accounting_finance' },
      { name: '広報・IR', value: 'public_relations_ir' },
      { name: 'コンプライアンス', value: 'compliance' },
      { name: 'リスク管理', value: 'risk_management' },
      { name: '知的財産', value: 'intellectual_property' },
      { name: 'CSR', value: 'csr' },
      { name: '海外・グローバル', value: 'overseas' },
      { name: 'イノベーション', value: 'innovation' },
      { name: '購買', value: 'purchasing' },
      { name: 'コーポレートコミュニケーション', value: 'corporate_communication' },
      { name: 'コーポレート', value: 'corporate' },
      { name: 'ブランド', value: 'brand' },
      { name: 'カスタマーサービス', value: 'customer_service' },
    ]
  },
  {
    name: 'セールス部門', value: 'sales_department', submenu: [
      { name: '営業企画', value: 'sales_planning' },
      { name: '営業推進', value: 'sales_promotion' },
      { name: '営業', value: 'sales' },
      { name: 'マーケティング', value: 'marketing' },
      { name: '販促・販売・プロモーション', value: 'promotion_sales' },
    ]
  },
  {
    name: '事業部門', value: 'business_department', submenu: [
      { name: '新規事業', value: 'new_business' },
      { name: '事業企画', value: 'business_plan' },
      { name: '事業推進', value: 'business_promotion' },
      { name: '事業戦略', value: 'business_strategy' },
      { name: '事業統括', value: 'business_management' },
      { name: 'オペレーション', value: 'operation' },
      { name: 'EC', value: 'ec' },
    ]
  },
  {
    name: 'プロダクト部門', value: 'product_department', submenu: [
      { name: '製造', value: 'manufacturing' },
      { name: '流通', value: 'flow' },
      { name: '技術', value: 'technology' },
      { name: '研究開発・R&D', value: 'r_and_d' },
      { name: '物流・SCM', value: 'distribution' },
      { name: '商品開発', value: 'product_development' },
      { name: 'システム開発', value: 'system_development' },
      { name: '品質管理', value: 'quality_management' },
      { name: '生産', value: 'production' },
      { name: '設計', value: 'architect' },
      { name: 'エレクトロニクス', value: 'electronics' },
      { name: 'インフラ', value: 'infra' }
    ]
  },
  {
    name: 'その他の部門', value: 'other_department', submenu: [
      { name: 'M&A・提携', value: 'partnership' },
      { name: '輸出・輸入', value: 'export_import' },
      { name: '戦略', value: 'strategy' },
      { name: '調達', value: 'supplies' },
      { name: '業務推進', value: 'operations' },
      { name: '監査', value: 'audit' },
      { name: '企画', value: 'planning' },
      { name: 'コンサルティング', value: 'consulting' },
      { name: 'ソリューション', value: 'solution' },
      { name: '開発', value: 'development' },
      { name: '資源・エネルギー', value: 'resources_energy' },
      { name: '資材・資本', value: 'materials' },
      { name: '貿易・渉外', value: 'trade' },
      { name: 'リテール', value: 'retail' },
      { name: 'ファイナンス', value: 'finance' },
      { name: '保険', value: 'insurance' },
      { name: '融資', value: 'loan' },
      { name: 'デザイン', value: 'design' },
      { name: 'セキュリティ', value: 'security' },
      { name: 'データ', value: 'data' },
      { name: 'バイオ', value: 'bio' },
      { name: '科学・化学', value: 'science' },
      { name: 'メディア', value: 'media' },
      { name: 'デジタル', value: 'digital' },
      { name: 'ヘルスケア', value: 'health_care' },
      { name: 'メディカル', value: 'medical' },
      { name: 'モビリティ', value: 'mobility' },
      { name: '店舗・ストア', value: 'store' },
      { name: 'その他', value: 'other' },
    ]
  },
]

// 業界
export const industryMenu = [
  //{name: 'IT・通信', value: 'it_communication'},
  //{name: 'インフラ', value: 'infrastructure'},
  //{name: 'サービス・小売', value: 'services_retail'},
  //{name: 'マスコミ・広告', value: 'media_advertisement'},
  //{name: 'メーカー', value: 'maker'},
  //{name: '医薬', value: 'medical'},
  //{name: '運輸・倉庫', value: 'transport_warehouse'},
  //{name: '金融', value: 'financial'},
  //{name: '建設', value: 'construction'},
  //{name: '商社', value: 'trading'},
  //{name: '不動産', value: 'real_estate'},
  { value: 'fishery_agriculture_forestry', name: '水産・農林業', submenu: [] },
  { value: 'mining', name: '鉱業', submenu: [] },
  { value: 'construction', name: '建設業', submenu: [] },
  {
    value: 'manufacturing', name: '製造業', submenu: [
      { value: 'foods', name: '食料品' },
      { value: 'textiles_and_apparels', name: '繊維製品' },
      { value: 'pulp_and_paper', name: 'パルプ・紙' },
      { value: 'woods', name: '木製品' },
      { value: 'chemicals', name: '化学' },
      { value: 'pharmaceutical', name: '医薬品' },
      { value: 'oil_and_coal products', name: '石油・石炭製品' },
      { value: 'rubber_products', name: 'ゴム製品' },
      { value: 'glass_and_ceramics_products', name: 'ガラス・土石製品' },
      { value: 'iron_and_steel', name: '鉄鋼' },
      { value: 'nonferrous_metals', name: '非鉄金属' },
      { value: 'metal_products', name: '金属製品' },
      { value: 'machinery', name: '機械' },
      { value: 'electric_appliances', name: '電気機器' },
      { value: 'transportation_equipment', name: '輸送用機器' },
      { value: 'precision_instruments', name: '精密機器' },
      { value: 'other_products', name: 'その他製品' },
      { value: 'manufacture_management_and_supporting_economics', name: '管理・補助的経済活動を行う事業所' },
    ]
  },
  { value: 'electric_power_and_gas', name: '電気・ガス業', submenu: [] },
  {
    value: 'transportation', name: '運輸・情報通信業', submenu: [
      { value: 'land_transportation', name: '陸運業' },
      { value: 'marine_transportation', name: '海運業' },
      { value: 'air_transportation', name: '空運業' },
      { value: 'warehousing_and_harbor_transportation', name: '倉庫・運輸関連業' },
      { value: 'information_and_communication', name: '情報・通信業' },
      { value: 'transportation_management_and_supporting_economics', name: '管理・補助的経済活動を行う事業所' },
    ]
  },
  {
    value: 'trading', name: '商業', submenu: [
      { value: 'wholesale_trade', name: '卸売業' },
      { value: 'retail_trade', name: '小売業' },
      { value: 'commerce_management_and_supporting_economics', name: '管理・補助的経済活動を行う事業所' },
    ]
  },
  {
    value: 'finance', name: '金融・保険業', submenu: [
      { value: 'banks', name: '銀行業' },
      { value: 'securities_and_commodities_futures', name: '証券、商品先物取引業' },
      { value: 'insurance', name: '保険業' },
      { value: 'other_financing_business', name: 'その他金融業' },
      { value: 'finance_management_and_supporting_economics', name: '管理・補助的経済活動を行う事業所' },
    ]
  },
  { value: 'real_estate', name: '不動産業', submenu: [] },
  { value: 'services', name: 'サービス業', submenu: [] },
  { value: 'accommodation_and_food_services', name: '宿泊業・飲食サービス業', submenu: [] },
  { value: 'life_services_and_entertainment', name: '生活関連サービス業・娯楽業', submenu: [] },
]

//jsic
export const jsicMenu = [{
  value: "製造業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（09食料品製造業）" },
    { value: "畜産食料品製造業" },
    { value: "水産食料品製造業" },
    { value: "野菜缶詰・果実缶詰・農産保存食料品製造業" },
    { value: "調味料製造業" },
    { value: "糖類製造業" },
    { value: "精穀・製粉業" },
    { value: "パン・菓子製造業" },
    { value: "動植物油脂製造業" },
    { value: "その他の食料品製造業" },
    { value: "管理，補助的経済活動を行う事業所（10飲料・たばこ・飼料製造業）" },
    { value: "清涼飲料製造業" },
    { value: "酒類製造業" },
    { value: "茶・コーヒー製造業（清涼飲料を除く）" },
    { value: "製氷業" },
    { value: "たばこ製造業" },
    { value: "飼料・有機質肥料製造業" },
    { value: "管理，補助的経済活動を行う事業所（11繊維工業）" },
    { value: "製糸業，紡績業，化学繊維・ねん糸等製造業" },
    { value: "織物業" },
    { value: "ニット生地製造業" },
    { value: "染色整理業" },
    { value: "綱・網・レース・繊維粗製品製造業" },
    { value: "外衣・シャツ製造業（和式を除く）" },
    { value: "下着類製造業" },
    { value: "和装製品・その他の衣服・繊維製身の回り品製造業" },
    { value: "その他の繊維製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（12木材・木製品製造業）" },
    { value: "製材業，木製品製造業" },
    { value: "造作材・合板・建築用組立材料製造業" },
    { value: "木製容器製造業（竹，とうを含む）" },
    { value: "その他の木製品製造業(竹，とうを含む)" },
    { value: "管理，補助的経済活動を行う事業所（13家具・装備品製造業）" },
    { value: "家具製造業" },
    { value: "宗教用具製造業" },
    { value: "建具製造業" },
    { value: "その他の家具・装備品製造業" },
    { value: "管理，補助的経済活動を行う事業所（14パルプ・紙・紙加工品製造業）" },
    { value: "パルプ製造業" },
    { value: "紙製造業" },
    { value: "加工紙製造業" },
    { value: "紙製品製造業" },
    { value: "紙製容器製造業" },
    { value: "その他のパルプ・紙・紙加工品製造業" },
    { value: "管理，補助的経済活動を行う事業所（15印刷・同関連業）" },
    { value: "印刷業" },
    { value: "製版業" },
    { value: "製本業，印刷物加工業" },
    { value: "印刷関連サービス業" },
    { value: "管理，補助的経済活動を行う事業所（16化学工業）" },
    { value: "化学肥料製造業" },
    { value: "無機化学工業製品製造業" },
    { value: "有機化学工業製品製造業" },
    { value: "油脂加工製品・石けん・合成洗剤・界面活性剤・塗料製造業" },
    { value: "医薬品製造業" },
    { value: "化粧品・歯磨・その他の化粧用調整品製造業" },
    { value: "その他の化学工業" },
    { value: "管理，補助的経済活動を行う事業所（17石油製品・石炭製品製造業）" },
    { value: "石油精製業" },
    { value: "潤滑油・グリース製造業（石油精製業によらないもの）" },
    { value: "コークス製造業" },
    { value: "舗装材料製造業" },
    { value: "その他の石油製品・石炭製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（18プラスチック製品製造業）" },
    { value: "プラスチック板・棒・管・継手・異形押出製品製造業" },
    { value: "プラスチックフィルム・シート・床材・合成皮革製造業" },
    { value: "工業用プラスチック製品製造業" },
    { value: "発泡・強化プラスチック製品製造業" },
    { value: "プラスチック成形材料製造業（廃プラスチックを含む）" },
    { value: "その他のプラスチック製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（19ゴム製品製造業）" },
    { value: "タイヤ・チューブ製造業" },
    { value: "ゴム製・プラスチック製履物・同附属品製造業" },
    { value: "ゴムベルト・ゴムホース・工業用ゴム製品製造業" },
    { value: "その他のゴム製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（20なめし革・同製品・毛皮製造業）" },
    { value: "なめし革製造業" },
    { value: "工業用革製品製造業（手袋を除く）" },
    { value: "革製履物用材料・同附属品製造業" },
    { value: "革製履物製造業" },
    { value: "革製手袋製造業" },
    { value: "かばん製造業" },
    { value: "袋物製造業" },
    { value: "毛皮製造業" },
    { value: "その他のなめし革製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（21窯業・土石製品製造業）" },
    { value: "ガラス・同製品製造業" },
    { value: "セメント・同製品製造業" },
    { value: "建設用粘土製品製造業（陶磁器製を除く)" },
    { value: "陶磁器・同関連製品製造業" },
    { value: "耐火物製造業" },
    { value: "炭素・黒鉛製品製造業" },
    { value: "研磨材・同製品製造業" },
    { value: "骨材・石工品等製造業" },
    { value: "その他の窯業・土石製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（22鉄鋼業）" },
    { value: "製鉄業" },
    { value: "製鋼・製鋼圧延業" },
    { value: "製鋼を行わない鋼材製造業（表面処理鋼材を除く）" },
    { value: "表面処理鋼材製造業" },
    { value: "鉄素形材製造業" },
    { value: "その他の鉄鋼業" },
    { value: "管理，補助的経済活動を行う事業所（23非鉄金属製造業）" },
    { value: "非鉄金属第１次製錬・精製業" },
    { value: "非鉄金属第２次製錬・精製業（非鉄金属合金製造業を含む）" },
    { value: "非鉄金属・同合金圧延業（抽伸，押出しを含む）" },
    { value: "電線・ケーブル製造業" },
    { value: "非鉄金属素形材製造業" },
    { value: "その他の非鉄金属製造業" },
    { value: "管理，補助的経済活動を行う事業所（24金属製品製造業）" },
    { value: "ブリキ缶・その他のめっき板等製品製造業" },
    { value: "洋食器・刃物・手道具・金物類製造業" },
    { value: "暖房・調理等装置,配管工事用附属品製造業" },
    { value: "建設用・建築用金属製品製造業（製缶板金業を含む)" },
    { value: "金属素形材製品製造業" },
    { value: "金属被覆・彫刻業，熱処理業（ほうろう鉄器を除く）" },
    { value: "金属線製品製造業（ねじ類を除く)" },
    { value: "ボルト・ナット・リベット・小ねじ・木ねじ等製造業" },
    { value: "その他の金属製品製造業" },
    { value: "管理，補助的経済活動を行う事業所（25はん用機械器具製造業）" },
    { value: "ボイラ・原動機製造業" },
    { value: "ポンプ・圧縮機器製造業" },
    { value: "一般産業用機械・装置製造業" },
    { value: "その他のはん用機械・同部分品製造業" },
    { value: "管理，補助的経済活動を行う事業所（26生産用機械器具製造業）" },
    { value: "農業用機械製造業（農業用器具を除く）" },
    { value: "建設機械・鉱山機械製造業" },
    { value: "繊維機械製造業" },
    { value: "生活関連産業用機械製造業" },
    { value: "基礎素材産業用機械製造業" },
    { value: "金属加工機械製造業" },
    { value: "半導体・フラットパネルディスプレイ製造装置製造業" },
    { value: "その他の生産用機械・同部分品製造業" },
    { value: "管理，補助的経済活動を行う事業所（27業務用機械器具製造業）" },
    { value: "事務用機械器具製造業" },
    { value: "サービス用・娯楽用機械器具製造業" },
    { value: "計量器・測定器・分析機器・試験機・測量機械器具・理化学機械器具製造業" },
    { value: "医療用機械器具・医療用品製造業" },
    { value: "光学機械器具・レンズ製造業" },
    { value: "武器製造業" },
    { value: "管理，補助的経済活動を行う事業所（28電子部品・デバイス・電子回路製造業）" },
    { value: "電子デバイス製造業" },
    { value: "電子部品製造業" },
    { value: "記録メディア製造業" },
    { value: "電子回路製造業" },
    { value: "ユニット部品製造業" },
    { value: "その他の電子部品・デバイス・電子回路製造業" },
    { value: "管理，補助的経済活動を行う事業所（29電気機械器具製造業）" },
    { value: "発電用・送電用・配電用電気機械器具製造業" },
    { value: "産業用電気機械器具製造業" },
    { value: "民生用電気機械器具製造業" },
    { value: "電球・電気照明器具製造業" },
    { value: "電池製造業" },
    { value: "電子応用装置製造業" },
    { value: "電気計測器製造業" },
    { value: "その他の電気機械器具製造業" },
    { value: "管理，補助的経済活動を行う事業所（30情報通信機械器具製造業）" },
    { value: "通信機械器具・同関連機械器具製造業" },
    { value: "映像・音響機械器具製造業" },
    { value: "電子計算機・同附属装置製造業" },
    { value: "管理，補助的経済活動を行う事業所（31輸送用機械器具製造業）" },
    { value: "自動車・同附属品製造業" },
    { value: "鉄道車両・同部分品製造業" },
    { value: "船舶製造・修理業，舶用機関製造業" },
    { value: "航空機・同附属品製造業" },
    { value: "産業用運搬車両・同部分品・附属品製造業" },
    { value: "その他の輸送用機械器具製造業" },
    { value: "管理，補助的経済活動を行う事業所（32その他の製造業）" },
    { value: "貴金属・宝石製品製造業" },
    { value: "装身具・装飾品・ボタン・同関連品製造業（貴金属・宝石製を除く）" },
    { value: "時計・同部分品製造業" },
    { value: "楽器製造業" },
    { value: "がん具・運動用具製造業" },
    { value: "ペン・鉛筆・絵画用品・その他の事務用品製造業" },
    { value: "漆器製造業" },
    { value: "畳等生活雑貨製品製造業" },
    { value: "他に分類されない製造業" }
  ]
}, {
  value: "鉱業，採石業，砂利採取業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（05鉱業，採石業，砂利採取業）" },
    { value: "金属鉱業" },
    { value: "石炭・亜炭鉱業" },
    { value: "原油・天然ガス鉱業" },
    { value: "採石業，砂・砂利・玉石採取業" },
    { value: "窯業原料用鉱物鉱業（耐火物・陶磁器・ガラス・セメント原料用に限る）" },
    { value: "その他の鉱業" }
  ]
}, {
  value: "サービス業（他に分類されないもの）",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（88廃棄物処理業）" },
    { value: "一般廃棄物処理業" },
    { value: "産業廃棄物処理業" },
    { value: "その他の廃棄物処理業" },
    { value: "管理，補助的経済活動を行う事業所（89自動車整備業）" },
    { value: "自動車整備業" },
    { value: "管理，補助的経済活動を行う事業所（90機械等修理業）" },
    { value: "機械修理業（電気機械器具を除く）" },
    { value: "電気機械器具修理業" },
    { value: "表具業" },
    { value: "その他の修理業" },
    { value: "管理，補助的経済活動を行う事業所（91職業紹介・労働者派遣業）" },
    { value: "職業紹介業" },
    { value: "労働者派遣業" },
    { value: "管理，補助的経済活動を行う事業所（92その他の事業サービス業）" },
    { value: "速記・ワープロ入力・複写業" },
    { value: "建物サービス業" },
    { value: "警備業" },
    { value: "他に分類されない事業サービス業" },
    { value: "経済団体" },
    { value: "労働団体" },
    { value: "学術・文化団体" },
    { value: "政治団体" },
    { value: "他に分類されない非営利的団体" },
    { value: "神道系宗教" },
    { value: "仏教系宗教" },
    { value: "キリスト教系宗教" },
    { value: "その他の宗教" },
    { value: "管理，補助的経済活動を行う事業所（95その他のサービス業）" },
    { value: "集会場" },
    { value: "と畜場" },
    { value: "他に分類されないサービス業" },
    { value: "外国公館" },
    { value: "その他の外国公務" }
  ]
}, {
  value: "複合サービス事業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（86郵便局）" },
    { value: "郵便局" },
    { value: "郵便局受託業" },
    { value: "管理，補助的経済活動を行う事業所（87協同組合）" },
    { value: "農林水産業協同組合（他に分類されないもの）" },
    { value: "事業協同組合（他に分類されないもの）" }
  ]
}, {
  value: "建設業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（06総合工事業）" },
    { value: "一般土木建築工事業" },
    { value: "土木工事業（舗装工事業を除く）" },
    { value: "舗装工事業" },
    { value: "建築工事業(木造建築工事業を除く)" },
    { value: "木造建築工事業" },
    { value: "建築リフォーム工事業" },
    { value: "管理，補助的経済活動を行う事業所（07職別工事業）" },
    { value: "大工工事業" },
    { value: "とび・土工・コンクリート工事業" },
    { value: "鉄骨・鉄筋工事業" },
    { value: "石工・れんが・タイル・ブロック工事業" },
    { value: "左官工事業" },
    { value: "板金・金物工事業" },
    { value: "塗装工事業" },
    { value: "床・内装工事業" },
    { value: "その他の職別工事業" },
    { value: "管理，補助的経済活動を行う事業所（08設備工事業）" },
    { value: "電気工事業" },
    { value: "電気通信・信号装置工事業" },
    { value: "管工事業（さく井工事業を除く）" },
    { value: "機械器具設置工事業" },
    { value: "その他の設備工事業" }
  ]
}, {
  value: "学術研究，専門・技術サービス業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（71学術・開発研究機関）" },
    { value: "自然科学研究所" },
    { value: "人文・社会科学研究所" },
    { value: "管理，補助的経済活動を行う事業所（72専門サービス業）" },
    { value: "法律事務所，特許事務所" },
    { value: "公証人役場，司法書士事務所，土地家屋調査士事務所" },
    { value: "行政書士事務所" },
    { value: "公認会計士事務所，税理士事務所" },
    { value: "社会保険労務士事務所" },
    { value: "デザイン業" },
    { value: "著述・芸術家業" },
    { value: "経営コンサルタント業，純粋持株会社" },
    { value: "その他の専門サービス業" },
    { value: "管理，補助的経済活動を行う事業所（73広告業）" },
    { value: "広告業" },
    { value: "管理，補助的経済活動を行う事業所（74技術サービス業）" },
    { value: "獣医業" },
    { value: "土木建築サービス業" },
    { value: "機械設計業" },
    { value: "商品・非破壊検査業" },
    { value: "計量証明業" },
    { value: "写真業" },
    { value: "その他の技術サービス業" }
  ]
}, {
  value: "医療，福祉",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（83医療業）" },
    { value: "病院" },
    { value: "一般診療所" },
    { value: "歯科診療所" },
    { value: "助産・看護業" },
    { value: "療術業" },
    { value: "医療に附帯するサービス業" },
    { value: "管理，補助的経済活動を行う事業所（84保健衛生）" },
    { value: "保健所" },
    { value: "健康相談施設" },
    { value: "その他の保健衛生" },
    { value: "管理，補助的経済活動を行う事業所（85社会保険・社会福祉・介護事業）" },
    { value: "社会保険事業団体" },
    { value: "福祉事務所" },
    { value: "児童福祉事業" },
    { value: "老人福祉・介護事業" },
    { value: "障害者福祉事業" },
    { value: "その他の社会保険・社会福祉・介護事業" }
  ]
}, {
  value: "公務（他に分類されるものを除く）",
  submenu: [
    { value: "立法機関" },
    { value: "司法機関" },
    { value: "行政機関" },
    { value: "都道府県機関" },
    { value: "市町村機関" }
  ]
}, {
  value: "情報通信業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（37通信業）" },
    { value: "固定電気通信業" },
    { value: "移動電気通信業" },
    { value: "電気通信に附帯するサービス業" },
    { value: "管理，補助的経済活動を行う事業所（38放送業）" },
    { value: "公共放送業（有線放送業を除く）" },
    { value: "民間放送業（有線放送業を除く）" },
    { value: "有線放送業" },
    { value: "管理，補助的経済活動を行う事業所（39情報サービス業）" },
    { value: "ソフトウェア業" },
    { value: "情報処理・提供サービス業" },
    { value: "管理，補助的経済活動を行う事業所（40インターネット附随サービス業）" },
    { value: "インターネット附随サービス業" },
    { value: "管理，補助的経済活動を行う事業所（41映像・音声・文字情報制作業）" },
    { value: "映像情報制作・配給業" },
    { value: "音声情報制作業" },
    { value: "新聞業" },
    { value: "出版業" },
    { value: "広告制作業" },
    { value: "映像・音声・文字情報制作に附帯するサービス業" }
  ]
}, {
  value: "漁業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（03漁業）" },
    { value: "海面漁業" },
    { value: "内水面漁業" },
    { value: "管理，補助的経済活動を行う事業所（04水産養殖業）" },
    { value: "海面養殖業" },
    { value: "内水面養殖業" }
  ]
}, {
  value: "分類不能の産業",
  submenu: [
    { value: "分類不能の産業" }
  ]
}, {
  value: "不動産業，物品賃貸業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（68不動産取引業）" },
    { value: "建物売買業，土地売買業" },
    { value: "不動産代理業・仲介業" },
    { value: "管理，補助的経済活動を行う事業所（69不動産賃貸業・管理業）" },
    { value: "不動産賃貸業（貸家業，貸間業を除く）" },
    { value: "貸家業，貸間業" },
    { value: "駐車場業" },
    { value: "不動産管理業" },
    { value: "管理，補助的経済活動を行う事業所（70物品賃貸業）" },
    { value: "各種物品賃貸業" },
    { value: "産業用機械器具賃貸業" },
    { value: "事務用機械器具賃貸業" },
    { value: "自動車賃貸業" },
    { value: "スポーツ・娯楽用品賃貸業" },
    { value: "その他の物品賃貸業" }
  ]
}, {
  value: "農業，林業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（01農業）" },
    { value: "耕種農業" },
    { value: "畜産農業" },
    { value: "農業サービス業（園芸サービス業を除く）" },
    { value: "園芸サービス業" },
    { value: "管理，補助的経済活動を行う事業所（02林業）" },
    { value: "育林業" },
    { value: "素材生産業" },
    { value: "特用林産物生産業（きのこ類の栽培を除く）" },
    { value: "林業サービス業" },
    { value: "その他の林業" }
  ]
}, {
  value: "金融業，保険業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（62銀行業）" },
    { value: "中央銀行" },
    { value: "銀行（中央銀行を除く）" },
    { value: "管理，補助的経済活動を行う事業所（63協同組織金融業）" },
    { value: "中小企業等金融業" },
    { value: "農林水産金融業" },
    { value: "管理，補助的経済活動を行う事業所（64貸金業，クレジットカード業等非預金信用機関）" },
    { value: "貸金業" },
    { value: "質屋" },
    { value: "クレジットカード業，割賦金融業" },
    { value: "その他の非預金信用機関" },
    { value: "管理，補助的経済活動を行う事業所（65金融商品取引業，商品先物取引業）" },
    { value: "金融商品取引業" },
    { value: "商品先物取引業，商品投資顧問業" },
    { value: "管理，補助的経済活動を行う事業所（66補助的金融業等）" },
    { value: "補助的金融業，金融附帯業" },
    { value: "信託業" },
    { value: "金融代理業" },
    { value: "管理，補助的経済活動を行う事業所（67保険業）" },
    { value: "生命保険業" },
    { value: "損害保険業" },
    { value: "共済事業・少額短期保険業" },
    { value: "保険媒介代理業" },
    { value: "保険サービス業" }
  ]
}, {
  value: "卸売業，小売業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（50各種商品卸売業）" },
    { value: "各種商品卸売業" },
    { value: "管理，補助的経済活動を行う事業所（51繊維・衣服等卸売業）" },
    { value: "繊維品卸売業（衣服，身の回り品を除く）" },
    { value: "衣服卸売業" },
    { value: "身の回り品卸売業" },
    { value: "管理，補助的経済活動を行う事業所（52飲食料品卸売業）" },
    { value: "農畜産物・水産物卸売業" },
    { value: "食料・飲料卸売業" },
    { value: "管理，補助的経済活動を行う事業所（53建築材料，鉱物・金属材料等卸売業）" },
    { value: "建築材料卸売業" },
    { value: "化学製品卸売業" },
    { value: "石油・鉱物卸売業" },
    { value: "鉄鋼製品卸売業" },
    { value: "非鉄金属卸売業" },
    { value: "再生資源卸売業" },
    { value: "管理，補助的経済活動を行う事業所（54機械器具卸売業）" },
    { value: "産業機械器具卸売業" },
    { value: "自動車卸売業" },
    { value: "電気機械器具卸売業" },
    { value: "その他の機械器具卸売業" },
    { value: "管理，補助的経済活動を行う事業所（55その他の卸売業）" },
    { value: "家具・建具・じゅう器等卸売業" },
    { value: "医薬品・化粧品等卸売業" },
    { value: "紙・紙製品卸売業" },
    { value: "他に分類されない卸売業" },
    { value: "管理，補助的経済活動を行う事業所（56各種商品小売業）" },
    { value: "百貨店，総合スーパー" },
    { value: "その他の各種商品小売業（従業者が常時50人未満のもの）" },
    { value: "管理，補助的経済活動を行う事業所（57織物・衣服・身の回り品小売業）" },
    { value: "呉服・服地・寝具小売業" },
    { value: "男子服小売業" },
    { value: "婦人・子供服小売業" },
    { value: "靴・履物小売業" },
    { value: "その他の織物・衣服・身の回り品小売業" },
    { value: "管理，補助的経済活動を行う事業所（58飲食料品小売業）" },
    { value: "各種食料品小売業" },
    { value: "野菜・果実小売業" },
    { value: "食肉小売業" },
    { value: "鮮魚小売業" },
    { value: "酒小売業" },
    { value: "菓子・パン小売業" },
    { value: "その他の飲食料品小売業" },
    { value: "管理，補助的経済活動を行う事業所（59機械器具小売業）" },
    { value: "自動車小売業" },
    { value: "自転車小売業" },
    { value: "機械器具小売業（自動車，自転車を除く）" },
    { value: "管理，補助的経済活動を行う事業所（60その他の小売業）" },
    { value: "家具・建具・畳小売業" },
    { value: "じゅう器小売業" },
    { value: "医薬品・化粧品小売業" },
    { value: "農耕用品小売業" },
    { value: "燃料小売業" },
    { value: "書籍・文房具小売業" },
    { value: "スポーツ用品・がん具・娯楽用品・楽器小売業" },
    { value: "写真機・時計・眼鏡小売業" },
    { value: "他に分類されない小売業" },
    { value: "管理，補助的経済活動を行う事業所（61無店舗小売業）" },
    { value: "通信販売・訪問販売小売業" },
    { value: "自動販売機による小売業" },
    { value: "その他の無店舗小売業" }
  ]
}, {
  value: "電気・ガス・熱供給・水道業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（33電気業）" },
    { value: "電気業" },
    { value: "管理，補助的経済活動を行う事業所（34ガス業）" },
    { value: "ガス業" },
    { value: "管理，補助的経済活動を行う事業所（35熱供給業）" },
    { value: "熱供給業" },
    { value: "管理，補助的経済活動を行う事業所（36水道業）" },
    { value: "上水道業" },
    { value: "工業用水道業" },
    { value: "下水道業" }
  ]
}, {
  value: "宿泊業，飲食サービス業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（75宿泊業）" },
    { value: "旅館，ホテル" },
    { value: "簡易宿所" },
    { value: "下宿業" },
    { value: "その他の宿泊業" },
    { value: "管理，補助的経済活動を行う事業所（76飲食店）" },
    { value: "食堂，レストラン（専門料理店を除く）" },
    { value: "専門料理店" },
    { value: "そば・うどん店" },
    { value: "すし店" },
    { value: "酒場，ビヤホール" },
    { value: "バー，キャバレー，ナイトクラブ" },
    { value: "喫茶店" },
    { value: "その他の飲食店" },
    { value: "管理，補助的経済活動を行う事業所（77持ち帰り・配達飲食サービス業）" },
    { value: "持ち帰り飲食サービス業" },
    { value: "配達飲食サービス業" }
  ]
}, {
  value: "運輸業，郵便業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（42鉄道業）" },
    { value: "鉄道業" },
    { value: "管理，補助的経済活動を行う事業所（43道路旅客運送業）" },
    { value: "一般乗合旅客自動車運送業" },
    { value: "一般乗用旅客自動車運送業" },
    { value: "一般貸切旅客自動車運送業" },
    { value: "その他の道路旅客運送業" },
    { value: "管理，補助的経済活動を行う事業所（44道路貨物運送業）" },
    { value: "一般貨物自動車運送業" },
    { value: "特定貨物自動車運送業" },
    { value: "貨物軽自動車運送業" },
    { value: "集配利用運送業" },
    { value: "その他の道路貨物運送業" },
    { value: "管理，補助的経済活動を行う事業所（45水運業）" },
    { value: "外航海運業" },
    { value: "沿海海運業" },
    { value: "内陸水運業" },
    { value: "船舶貸渡業" },
    { value: "管理，補助的経済活動を行う事業所（46航空運輸業）" },
    { value: "航空運送業" },
    { value: "航空機使用業（航空運送業を除く）" },
    { value: "管理，補助的経済活動を行う事業所（47倉庫業）" },
    { value: "倉庫業（冷蔵倉庫業を除く）" },
    { value: "冷蔵倉庫業" },
    { value: "管理，補助的経済活動を行う事業所（48運輸に附帯するサービス業）" },
    { value: "港湾運送業" },
    { value: "貨物運送取扱業（集配利用運送業を除く）" },
    { value: "運送代理店" },
    { value: "こん包業" },
    { value: "運輸施設提供業" },
    { value: "その他の運輸に附帯するサービス業" },
    { value: "管理，補助的経済活動を行う事業所（49郵便業）" },
    { value: "郵便業（信書便事業を含む）" }
  ]
}, {
  value: "生活関連サービス業，娯楽業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（78洗濯・理容・美容・浴場業）" },
    { value: "洗濯業" },
    { value: "理容業" },
    { value: "美容業" },
    { value: "一般公衆浴場業" },
    { value: "その他の公衆浴場業" },
    { value: "その他の洗濯・理容・美容・浴場業" },
    { value: "管理，補助的経済活動を行う事業所（79その他の生活関連サービス業）" },
    { value: "旅行業" },
    { value: "家事サービス業" },
    { value: "衣服裁縫修理業" },
    { value: "物品預り業" },
    { value: "火葬・墓地管理業" },
    { value: "冠婚葬祭業" },
    { value: "他に分類されない生活関連サービス業" },
    { value: "管理，補助的経済活動を行う事業所（80娯楽業）" },
    { value: "映画館" },
    { value: "興行場（別掲を除く），興行団" },
    { value: "競輪・競馬等の競走場，競技団" },
    { value: "スポーツ施設提供業" },
    { value: "公園，遊園地" },
    { value: "遊戯場" },
    { value: "その他の娯楽業" }
  ]
}, {
  value: "教育，学習支援業",
  submenu: [
    { value: "管理，補助的経済活動を行う事業所（81学校教育）" },
    { value: "幼稚園" },
    { value: "小学校" },
    { value: "中学校" },
    { value: "高等学校，中等教育学校" },
    { value: "特別支援学校" },
    { value: "高等教育機関" },
    { value: "専修学校，各種学校" },
    { value: "学校教育支援機関" },
    { value: "幼保連携型認定こども園" },
    { value: "管理，補助的経済活動を行う事業所（82その他の教育，学習支援業）" },
    { value: "社会教育" },
    { value: "職業・教育支援施設" },
    { value: "学習塾" },
    { value: "教養・技能教授業" },
    { value: "他に分類されない教育，学習支援業" }
  ]
}]

//地域
export const prefectureNameMenu = [
  {
    value: '北海道', name: '北海道', submenu: [
      { value: '北海道', name: '北海道' },
    ]
  },
  {
    value: '東北', name: '東北', submenu: [
      { value: '青森県', name: '青森県' },
      { value: '岩手県', name: '岩手県' },
      { value: '宮城県', name: '宮城県' },
      { value: '秋田県', name: '秋田県' },
      { value: '山形県', name: '山形県' },
      { value: '福島県', name: '福島県' },
    ]
  },
  {
    value: '関東', name: '関東', submenu: [
      { value: '茨城県', name: '茨城県' },
      { value: '栃木県', name: '栃木県' },
      { value: '群馬県', name: '群馬県' },
      { value: '埼玉県', name: '埼玉県' },
      { value: '千葉県', name: '千葉県' },
      { value: '東京都', name: '東京都' },
      { value: '神奈川県', name: '神奈川県' },
    ]
  },
  {
    value: '北陸', name: '北陸', submenu: [
      { value: '新潟県', name: '新潟県' },
      { value: '富山県', name: '富山県' },
      { value: '石川県', name: '石川県' },
      { value: '福井県', name: '福井県' },
    ]
  },
  {
    value: '中部', name: '中部', submenu: [
      { value: '山梨県', name: '山梨県' },
      { value: '長野県', name: '長野県' },
      { value: '岐阜県', name: '岐阜県' },
      { value: '静岡県', name: '静岡県' },
      { value: '愛知県', name: '愛知県' },
    ]
  },
  {
    value: '関西', name: '関西', submenu: [
      { value: '三重県', name: '三重県' },
      { value: '滋賀県', name: '滋賀県' },
      { value: '奈良県', name: '奈良県' },
      { value: '和歌山県', name: '和歌山県' },
      { value: '京都府', name: '京都府' },
      { value: '大阪府', name: '大阪府' },
      { value: '兵庫県', name: '兵庫県' },
    ]
  },
  {
    value: '中国', name: '中国', submenu: [
      { value: '岡山県', name: '岡山県' },
      { value: '広島県', name: '広島県' },
      { value: '鳥取県', name: '鳥取県' },
      { value: '島根県', name: '島根県' },
      { value: '山口県', name: '山口県' },
    ]
  },
  {
    value: '四国', name: '四国', submenu: [
      { value: '香川県', name: '香川県' },
      { value: '徳島県', name: '徳島県' },
      { value: '愛媛県', name: '愛媛県' },
      { value: '高知県', name: '高知県' },
    ]
  },
  {
    value: '九州', name: '九州', submenu: [
      { value: '福岡県', name: '福岡県' },
      { value: '佐賀県', name: '佐賀県' },
      { value: '長崎県', name: '長崎県' },
      { value: '大分県', name: '大分県' },
      { value: '熊本県', name: '熊本県' },
      { value: '宮崎県', name: '宮崎県' },
      { value: '鹿児島県', name: '鹿児島県' },
    ]
  },
  {
    value: '沖縄', name: '沖縄', submenu: [
      { value: '沖縄県', name: '沖縄県' },
    ]
  },
]

// 売上高
export const amountOfSalesMenu = [
  { name: '1億円未満', value: 'yen_less_than_1' },
  { name: '1億〜3億円未満', value: 'yen_1_3' },
  { name: '3億〜10億円未満', value: 'yen_3_10' },
  { name: '10億〜50億円未満', value: 'yen_10_50' },
  { name: '50億〜100億円未満', value: 'yen_50_100' },
  { name: '100億〜200億円未満', value: 'yen_100_200' },
  { name: '200億〜300億円未満', value: 'yen_200_300' },
  { name: '300億〜400億円未満', value: 'yen_300_400' },
  { name: '400億〜500億円未満', value: 'yen_400_500' },
  { name: '500億〜600億円未満', value: 'yen_500_600' },
  { name: '600億〜700億円未満', value: 'yen_600_700' },
  { name: '700億〜800億円未満', value: 'yen_700_800' },
  { name: '800億〜900億円未満', value: 'yen_800_900' },
  { name: '900億〜1000億円未満', value: 'yen_900_1000' },
  { name: '1000億〜3000億円未満', value: 'yen_1000_3000' },
  { name: '3000億円以上', value: 'yen_3000_over' },
]

// 従業員数
export const numberOfEmployeesMenu = [
  { name: '5人未満 ', value: 'people_less_than_5' },
  { name: '5人〜10人未満', value: 'people_5_10' },
  { name: '10人〜50人未満', value: 'people_10_50' },
  { name: '50人〜150人未満', value: 'people_50_150' },
  { name: '150人〜300人未満', value: 'people_150_300' },
  { name: '300人〜500人未満', value: 'people_300_500' },
  { name: '500人〜1000人未満', value: 'people_500_1000' },
  { name: '1000人〜3000人未満', value: 'people_1000_3000' },
  { name: '3000人〜5000人未満', value: 'people_3000_5000' },
  { name: '5000人〜1万人未満', value: 'people_5000_10000' },
  { name: '1万人以上', value: 'people_10000_over' },
]

// 店舗数
export const numberOfStoresMenu = [
  { name: '1〜10店舗', value: 'stores_1_10' },
  { name: '11〜50店舗', value: 'stores_11_50' },
  { name: '51〜100店舗', value: 'stores_51_100' },
  { name: '101〜500店舗', value: 'stores_101_500' },
  { name: '501〜1000店舗', value: 'stores_501_1000' },
  { name: '1001店舗以上', value: 'stores_1001_over' },
]

// 事業形態
export const businessTypeMenu = [
  { name: 'BtoB', value: 1 },
  { name: 'BtoC', value: 2 },
  { name: '事業形態不明', value: 0 },
]

// 資本金
export const capitalStockMenu = [
  { name: '5000万円未満', value: 'yen_less_than_5000' },
  { name: '5000万円〜3億円未満', value: 'yen_5000_30000' },
  { name: '3億〜10億円未満', value: 'yen_30000_1000000' },
  { name: '10億〜50億円未満', value: 'yen_1000000_5000000' },
  { name: '50億〜150億円未満', value: 'yen_5000000_150000000' },
  { name: '150億円以上', value: 'yen_150000000_over' },
]

// 上場市場
export const listingTypeMenu = [
  { name: '東証プライム', value: 'prime' },
  { name: '東証スタンダード', value: 'standard' },
  { name: '東証グロース', value: 'growth' },
  { name: 'TOKYO PRO Market', value: 'TOKYO_PRO_Market' },
  { name: '名証プレミア', value: 'premier' },
  { name: '名証メイン', value: 'main' },
  { name: '名証ネクスト', value: 'next' },
  { name: '福岡証券取引所', value: 'FSE' },
  { name: 'Q-Board', value: 'Q_Board' },
  { name: '札幌証券取引所', value: 'SSE' },
  { name: 'アンビシャス', value: 'ambitious' },
]

// 上場に関する状態
export const listingStatusMenu = [
  { name: '未上場', value: 'unlisted' },
  { name: '上場廃止', value: 'delisted' },
  { name: '直近12ヶ月以内に上場', value: 'last_12_months' },
]

// 決算月
export const clothingMonthMenu = [
  { name: '12月', value: 12 },
  { name: '11月', value: 11 },
  { name: '10月', value: 10 },
  { name: '9月', value: 9 },
  { name: '8月', value: 8 },
  { name: '7月', value: 7 },
  { name: '6月', value: 6 },
  { name: '5月', value: 5 },
  { name: '4月', value: 4 },
  { name: '3月', value: 3 },
  { name: '2月', value: 2 },
  { name: '1月', value: 1 },
]

// 平均年齢
export const averageAgeMenu = [
  { name: '30歳未満', value: 'age_less_than_30' },
  { name: '30歳〜40歳未満', value: 'age_30_40' },
  { name: '40歳〜50歳未満', value: 'age_40_50' },
  { name: '50歳以上', value: 'age_50_over' },
]

// 平均年収
export const averageAnnualIncomeMenu = [
  { name: '300万未満', value: 'income_less_than_300' },
  { name: '300万〜400万未満', value: 'income_300_400' },
  { name: '400万〜500万未満', value: 'income_400_500' },
  { name: '500万〜600万未満', value: 'income_500_600' },
  { name: '600万〜700万未満', value: 'income_600_700' },
  { name: '700万〜800万未満', value: 'income_700_800' },
  { name: '800万〜900万未満', value: 'income_800_900' },
  { name: '900万〜1000万未満', value: 'income_900_1000' },
  { name: '1,000万〜1,500万未満', value: 'income_1000_1500' },
  { name: '1,500万〜2,000万未満', value: 'income_1500_2000' },
  { name: '2,000万以上', value: 'income_2000_over' },
]

// 進退
export const excludeRetirementMenu = [
  { name: '退任した人を含めない', value: [true] },
  { name: '退任した人を含める', value: [true, false] },
  { name: '退任した人のみ表示', value: [false] }
]

// キャップするキーマンのソートの項目
export const capSortMenu = [
  { name: '未選択', value: '0' },
  { name: '着任日が新しい順', value: '1' },
  { name: '役職レイヤーの高い順', value: '2' }
]

// 登記簿変更の有無
export const differenceTypeMenu = [
  { name: '会社名変更', value: 1 },
  { name: '住所変更', value: 2 },
  { name: '閉鎖', value: 3 },
]

/**
 * 送付ステータス
 *
 * @see
 * ステータスは2桁単位で管理する
 * 2桁で管理することで、100で割ったときの整数部分でステータス、剰余で自分か自分以外を判別できる
 * 例: 101であれば 1 => 注文済みキーマンのみを表示, 2 => 自分, 202であれば 2 => 注文済みキーマンを除外, 2 => 自分以外
 * 引数のinputが
 * [
 *   0 => '101',
 *   1 => '102',
 *   2 => '201',
 * ]
 * だった場合、outputは
 * [
 *   0 => ['label_type' => 1, 'owner_type' => 0] ※ 601, 602だと、全て選択してるため、マージしてowner_typeは0になる
 *   1 => ['label_type' => 2, 'owner_type' => 1]
 * ]
 * になる
 *
 * フロントで共通コンポーネントを使っており、修正範囲がすくなるなるようにサーバー側で値を書き換えるようにしている。
 */
export const sentStatusMenu = [
  {
    name: '注文済みキーマンのみを表示', value: '1', submenu: [
      { name: '自分', value: '101' },
      { name: '自分以外', value: '102' },
    ]
  },
  {
    name: '注文済みキーマンを除外', value: '2', submenu: [
      { name: '自分', value: '201' },
      { name: '自分以外', value: '202' },
    ]
  }
];

export const corporationSentStatusMenu = [
  {
    name: '注文済み企業のみを表示', value: '1', submenu: [
      { name: '自分', value: '101' },
      { name: '自分以外', value: '102' },
    ]
  },
  {
    name: '注文済み企業を除外', value: '2', submenu: [
      { name: '自分', value: '201' },
      { name: '自分以外', value: '202' },
    ]
  }
];

export const followCallOrderStatusMenu = [
  {
    name: 'フォローコール依頼済みのみを表示', value: '1', submenu: [
      { name: '自分', value: '101' },
      { name: '自分以外', value: '102' },
    ]
  },
  {
    name: 'フォローコール依頼済みを除外', value: '2', submenu: [
      { name: '自分', value: '201' },
      { name: '自分以外', value: '202' },
    ]
  }
];

/**
 * 送付ステータス
 *
 * @see
 * ステータスは2桁単位で管理する
 * 2桁で管理することで、100で割ったときの整数部分でステータス、剰余で自分か自分以外を判別できる
 * 例: 101であれば 1 => ダウンロード済みのみを表示, 2 => 自分, 202であれば 2 => ダウンロード済みを除外, 2 => 自分以外
 * 引数のinputが
 * [
 *   0 => '101',
 *   1 => '102',
 *   2 => '201',
 * ]
 * だった場合、outputは
 * [
 *   0 => ['label_type' => 1, 'owner_type' => 0] ※ 601, 602だと、全て選択してるため、マージしてowner_typeは0になる
 *   1 => ['label_type' => 2, 'owner_type' => 1]
 * ]
 * になる
 *
 * フロントで共通コンポーネントを使っており、修正範囲がすくなるなるようにサーバー側で値を書き換えるようにしている。
 */
export const downloadStatusMenu = [
  {
    name: 'ダウンロード済みのみを表示', value: '1', submenu: [
      { name: '自分', value: '101' },
      { name: '自分以外', value: '102' },
    ]
  },
  {
    name: 'ダウンロード済みを除外', value: '2', submenu: [
      { name: '自分', value: '201' },
      { name: '自分以外', value: '202' },
    ]
  },
  {
    name: 'ダウンロード済みで更新されたキーマンを表示', value: '3', submenu: [
      { name: '自分', value: '301' },
      { name: '自分以外', value: '302' },
    ]
  },
];

/**
 * @see
 * ステータスは2桁単位で管理する
 * 2桁で管理することで、100で割ったときの整数部分でステータス、剰余で自分か自分以外を判別できる
 * 例: 601であれば 6 => アプローチ中(フォロー済み), 1 => 自分, 1102であれば 11 => 発送済み, 2 => 自分以外
 * 引数のinputが
 * [
 *   0 => '601',
 *   1 => '602',
 *   2 => '701',
 * ]
 * だった場合、outputは
 * [
 *   0 => ['label_type' => 6, 'owner_type' => 0] ※ 601, 602だと、全て選択してるため、マージしてowner_typeは0になる
 *   1 => ['label_type' => 7, 'owner_type' => 1]
 * ]
 * になる
 *
 * フロントで共通コンポーネントを使っており、修正範囲がすくなるなるようにサーバー側で値を書き換えるようにしている。
 */
export const statusMenu = [
  // {name: '未アプローチ', value: '4', submenu: []},
  {
    name: 'アプローチ中(フォロー済み)', value: '6', submenu: [
      { name: '自分', value: '601' },
      { name: '自分以外', value: '602' },
    ]
  },
  {
    name: 'アプローチ中(未フォロー)', value: '7', submenu: [
      { name: '自分', value: '701' },
      { name: '自分以外', value: '702' },
    ]
  },
  {
    name: '校了データ作成済み', value: '10', submenu: [
      { name: '自分', value: '1001' },
      { name: '自分以外', value: '1002' },
    ]
  },
  {
    name: '印刷中', value: '12', submenu: [
      { name: '自分', value: '1201' },
      { name: '自分以外', value: '1202' },
    ]
  },
  {
    name: '発送済み', value: '11', submenu: [
      { name: '自分', value: '1101' },
      { name: '自分以外', value: '1102' },
    ]
  },
  {
    name: 'リアクション(QRコード読み込み)', value: '5', submenu: [
      { name: '自分', value: '501' },
      { name: '自分以外', value: '502' },
    ]
  },
  {
    name: '未コネクト', value: '13', submenu: [
      { name: '自分', value: '1301' },
      { name: '自分以外', value: '1302' },
    ]
  },
  {
    name: 'お断り済み', value: '16', submenu: [
      { name: '自分', value: '1601' },
      { name: '自分以外', value: '1602' },
    ]
  },
  {
    name: 'コネクト', value: '14', submenu: [
      { name: '自分', value: '1401' },
      { name: '自分以外', value: '1402' },
    ]
  },
  {
    name: '資料送付', value: '15', submenu: [
      { name: '自分', value: '1501' },
      { name: '自分以外', value: '1502' },
    ]
  },
  {
    name: '商談成立', value: '1', submenu: [
      { name: '自分', value: '101' },
      { name: '自分以外', value: '102' },
    ]
  },
  {
    name: 'クローズ', value: '2', submenu: [
      { name: '自分', value: '201' },
      { name: '自分以外', value: '202' },
    ]
  },
  {
    name: 'アプローチNG', value: '3', submenu: [
      { name: '自分', value: '301' },
      { name: '自分以外', value: '302' },
    ]
  },
]

export const optionMenu = [
  { name: '決算報告書問い合わせ責任者', value: 'ir_exe' },
]

// タイトルに対して子のオプションがない「表示する人数を制限」等は
// 子と連動してタイトルにNEWラベルをつけることができないのでダミーのメニューを作成する
export const dummyMenuForTitleNew = [
  { name: '', isNew: true },
]

// 資金調達フィルタ用の定数
export const fundraisingDaysMenu = [
  { value: '', name: '指定なし' },
  { value: '7', name: '直近7日' },
  { value: '30', name: '直近30日' },
  { value: '90', name: '直近90日' },
];

export const fundraisingAmountRangeMenu = [
  { value: 'less_than_100m', name: '1億円未満' },
  { value: '100m_500m', name: '1億円〜5億円未満' },
  { value: '500m_1b', name: '5億円〜10億円未満' },
  { value: '1b_5b', name: '10億円〜50億円未満' },
  { value: '5b_over', name: '50億円以上' },
];

export const fundraisingRoundMenu = [
  { value: 'Seed', name: 'Seed' },
  { value: 'Pre-A', name: 'Pre-A' },
  { value: 'A', name: 'Series A' },
  { value: 'B', name: 'Series B' },
  { value: 'C', name: 'Series C' },
  { value: 'D', name: 'Series D' },
  { value: 'Pre-IPO', name: 'Pre-IPO' },
  { value: '上場増資', name: '上場増資/CB/社債' },
  { value: 'other', name: 'その他' },
];

export const fundraisingFinancingTypeMenu = [
  { value: 'equity', name: 'エクイティ' },
  { value: 'debt', name: 'デット' },
  { value: 'convertible', name: '転換社債' },
  { value: 'grant', name: '補助金/助成金' },
  { value: 'other', name: 'その他' },
];

export const fundraisingInvestorTypeMenu = [
  { value: 'vc', name: 'VC' },
  { value: 'cvc', name: 'CVC' },
  { value: 'corporate', name: '事業会社' },
  { value: 'bank', name: '銀行/金融機関' },
  { value: 'angel', name: '個人投資家' },
  { value: 'government', name: '政府系ファンド' },
  { value: 'other', name: 'その他' },
];

export const fundraisingAmountTypeMenu = [
  { value: 'single', name: '今回調達額' },
  { value: 'cumulative', name: '累計調達額' },
  { value: 'unknown', name: '不明' },
];



// WEBPACK FOOTER //
// ./src/constants/SidebarValues.js